import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import type { TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-tenant-name',
  templateUrl: './tenant-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class TenantNameComponent implements OnInit {
  private store = inject(Store);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  getAccessTenantList$: any;
  allTenants: any;

  ngOnInit(): void {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants = tenant.accessed_tenant;
    });
  }

  getTenant(tenantId: number) {
    return this.allTenants.find((o: { id: number }) => o.id == tenantId)!;
  }
}
